export default __webpack_public_path__ + "static/kindergarten-readiness3-36205a8268577d6d84b2a57650cd60a1.jpg";